// extracted by mini-css-extract-plugin
export default {"msgM":"d947c5abeb"};